/**
 * Application Context model
 */
export default class AppContext {
  /**
   * constructor
   * @param id String
   * @param name String
   * @param logo String
   */
  constructor({ id, name, logo }) {
    this.id = id
    this.name = name
    this.logo = logo
  }

  getId() {
    return this.id
  }

  getName() {
    return this.name
  }

  getLogo() {
    return this.logo
  }
}
